/* eslint-disable promise/always-return */
import {createSelector} from 'reselect';

import {get} from '@stubhub/rest-method';

const loginSelector = createSelector(
  (state, props) => state.login || /* istanbul ignore next*/ {},
  (login) => login.loginType
);
const primaryContactSelector = createSelector(
  (state) => state['login'] || {},
  (/* istanbul ignore next */ loginState = {}) => loginState.primaryContact || {}
);
export let reducers = {};

function getUserContact(userGuid) {
  return (dispatch, getState, {cookies}) => {
    dispatch({type: 'LOADING_CONTACT'});
    get({
      host: process.env.REACT_APP_API_HOST,
      path: `/bfm/user/customers/v1/${userGuid}/contactsV2`,
      json: true,
    })
      .then((payload) => {
        dispatch({
          type: 'USER_INFO_UPDATED',
          payload: (((payload || {}).contactsV2 || {}).contactV2 || []).filter((it) => it.defaultInd === 'Y'),
        });
      })
      .catch((e) => {
        dispatch({
          type: 'ERROR_CONTACT',
          error: e,
        });
      });
  };
}

reducers.USER_INFO_UPDATED = (state, action) => {
  return {...state, ...{login: {primaryContact: action.payload[0]}}};
};

export function mapStateToProps(state) {
  return {
    loginType: loginSelector(state),
    primaryContact: primaryContactSelector(state),
  };
}

export function mapDispatchToProps(dispatch, ownProps) {
  return {
    getUserContact: (userGuid) => dispatch(getUserContact(userGuid)),
    reset: () => dispatch({type: 'RESET_CONTACT'}),
  };
}
